import React from "react";
import { observer } from "mobx-react";
import List from "../../components/List";
import AuthenticationStore from "../../stores/AuthenticationStore";
import Stores from "../../stores/Stores";
import UIStore from "../../stores/UIStore";
import Edit from "./Edit";
import SearchField from "../../components/SearchField";
import SortPanel from "../../components/SortPanel";


const store = Stores.load("forum-reports", "id");

class ForumReports extends React.Component {
  componentDidMount() {
    UIStore.init("Denúncias", store);
  }

  handleDelete = () => {
    let count = store.selected.length;

    UIStore.showConfirmDialog(
      `Deseja remover ${count} denúncias?`,
      "Remover Denúncias"
    ).then((b) => {
      if (b) {
        store
          .delete()
          .then(() => store.query())
          .catch(() => alert("Erro!"));
      }
    });
  };

  handleFilter = () => {
    store.page = 0;
    store.searchAll = !store.searchAll;
    store.query();
  };

  render() {
    let canEdit;
    if (AuthenticationStore.me.role === "MANAGER") {
      canEdit = false;
    } else {
      canEdit = true;
    }

    return (
      <>
        <List
          store={store}
          data={store.list.map((i) => ({
            item: i,
            title: `Tópico: ${i.topic.title}`,
            content: (
              <>
                Criado em:{" "}
                {i.createdDate ? i.createdDate.formatTimeStamp() : ""}
              </>
            ),
          }))}
          status={store.list.map((i) => ({
            id: i.id,
            label: !i.topicPost ? "Tópico" : "Postagem",
            class: "finished-status",
          }))}
          rightPanel={
            <>
              <SortPanel
                store={store}
                filters={{
                  createdDate: "Data de Adição",
                }}
              />
              <SearchField store={store} />
            </>
          }
          onEdit={canEdit ? () => store.open() : null}
        />

        <Edit onSave={() => AuthenticationStore.testAuthenticated()} />
      </>
    );
  }
}

export default observer(ForumReports);
